import {Box, Skeleton} from '@mui/material';

export default function ScoringSystemsSkeleton() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Skeleton variant="rectangular" width="100%" height="60px" sx={{mb: 4}} />
      <Skeleton variant="rectangular" width="100%" height="300px" />
    </Box>
  );
}
